var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('VServiceTaskTableCell',[_c('li',[_vm._v("工程")]),_c('li',[_vm._v("現場名/施工者")]),_c('li',[_vm._v("メモ")]),_c('li',[_vm._v("発注者/監督")]),_c('li',[_vm._v("他工程")]),_c('li',[_vm._v("タスク")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }